<template>
    <span>        
        <feather-icon icon='InfoIcon' svgClasses="h-6 w-6 stoke-current text-danger" class='ml-1' v-if="params.node.data.hasOwnProperty('compromissoEntregaAtrasado')" />
    </span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: function () {
    return {};
  },
  computed: {      
  },
  beforeMount() {},
  mounted() {},
  methods: { },
});
</script>